// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__jzP0p","container":"Home_container__oxtwt","copy":"Home_copy__kZK5V","copyText":"Home_copyText__mKX9y","copyLink":"Home_copyLink__BqGPj"};